import { Button, CloseButton, Drawer, DrawerBody, DrawerContent, DrawerOverlay, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import FilterList from '@/assets/icons/ic-filter-list.svg';

import { PublisherFilter } from '@/components/ui/features/societies/PublisherFilter/PublisherFilter';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

export const PublisherFilterDrawer = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { query, change } = useQueryParams<{ subject_subtree_of_id: string; query: string }>({
    subject_subtree_of_id: StringParam,
    query: StringParam,
  });

  function reset() {
    change({ query, subject_subtree_of_id: null }, { method: 'replace', shallow: true });
  }

  return (
    <Drawer isOpen={isOpen} placement="left" onClose={onClose} size="md">
      <DrawerOverlay />
      <DrawerContent p={{ base: 5, md: 10 }}>
        <Flex mb={{ base: 5, md: 10 }} alignItems="center" justifyContent="space-between">
          <Button variant="unstyled" rightIcon={<FilterList color="#5B1CF4" />} onClick={reset}>
            {t('library.clearFilters')}
          </Button>
          <CloseButton onClick={onClose} />
        </Flex>

        <DrawerBody p={0}>
          <PublisherFilter />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
